exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".izvestaj-pozadina{background-color:#ccc;background-repeat:no-repeat;background-size:cover;height:24.3em;margin:0 auto;width:39.6em}.izvestaj{padding-top:12em}.izvestaj-potpis,.izvestaj-tekst{letter-spacing:.04em;line-height:1.2;padding-left:15%;padding-right:15%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/komponente/izvestaj/stil.css
// module id = 30
// module chunks = 0